"use client"
import { LogOut } from "lucide-react";
import { Button } from "@/components/shared/ui/button";
import { useTranslations } from "next-intl";
import { navbarLinks } from "@/constants/navbar";
import { Link, usePathname } from "@/navigation";
import useAuthStore from "@/store/authStore";

function DesktopNavbar() {
    const { isAuthenticated, logout } = useAuthStore()
    const t = useTranslations('Navbar');
    const pathname = usePathname();

    return (
        <div className="flex items-center justify-between w-full">
            {/* Navigation Links */}
            <div className="flex items-center justify-center gap-10">
                {navbarLinks.map((link, index) => (
                    <Button key={index} variant="ghost" asChild>
                        <Link href={link.href}>
                            <span className={`font-bold ${pathname === link.href ? "text-primary" : ""}`}>
                                {t(link.name)}
                            </span>
                        </Link>
                    </Button>
                ))}
            </div>

            {/* Auth Buttons */}
            <div className="flex items-center gap-2 space-x-4">
                {isAuthenticated ? (
                    <Button
                        variant="destructive"
                        className="gap-2 cursor-pointer px-6 py-4 rounded-xl"
                        asChild
                        onClick={logout}
                    >
                        <div>
                            <LogOut className="w-6 h-6" />
                            <span>{t('logout')}</span>
                        </div>
                    </Button>
                ) : (
                    <>
                        <Button 
                            variant="sub_primary" 
                            className="flex items-center gap-2 py-sub_text px-6 rounded-full" 
                            asChild
                        >
                            <Link href="/auth/signup">
                                <span>{t('signup')}</span>
                            </Link>
                        </Button>

                        <Button 
                            variant="sub_secondary" 
                            className="flex items-center gap-2 py-sub_text px-6 rounded-full" 
                            asChild
                        >
                            <Link href="/auth/login">
                                <span>{t('login')}</span>
                            </Link>
                        </Button>
                    </>
                )}
            </div>
        </div>
    );
}

export default DesktopNavbar;